import { QueueSettingEnum } from "../enums";
import { ExtensionModel } from "./ExtensionModel";

/**Модель шаблона */
export class TemplateModel {
  /**Id шаблона */
  Id?: string;
  /**Имя */
  Name?: string;
  /** */
  Data?: string;
  /**Тип настройки */
  Type?: QueueSettingEnum;

  /**Массив ExtensionModel полученный из Data */
  get ParsedData(): ExtensionModel[] {
    try {
      return JSON.parse(this.Data)?.map((x) => {
        delete x.Id;
        return new ExtensionModel(x);
      });
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  constructor(obj?: Partial<TemplateModel>) {
    if (obj) Object.assign(this, obj);
  }
}
